import React, { useEffect, useRef } from "react";

import api from "../services/api";
import { AUTORISATIONS_LECTEUR, origineSite, urlLecteurYoutube } from "../services/lecteurYoutube";

// Le lecteur est la page relais du site (/lecteur/youtube/<id>/), servie en https, partout
// (site, Windows, Android, Mac) :
// - elle transmet à YouTube un référent et une origine valides (sinon erreur 153 dans
//   l'app Mac, servie en tauri://localhost) ;
// - elle recouvre l'interface de YouTube (titre, partage, « Copier le lien », logo, clic
//   droit) et pilote la lecture avec ses propres boutons : le lien de la vidéo reste secret ;
// - elle renvoie l'état et la position de lecture par postMessage.
const ETATS_FIN = new Set([0, 2]); // terminé, en pause

// Lecteur vidéo qui enregistre la position et le pourcentage regardé.
export default function VideoSuivie({ videoId, ytId, titre, depart: departDemande = 0, onProgression }) {
  // Position de départ figée à l'ouverture : la progression enregistrée pendant la lecture
  // (pause, fin) ne doit pas changer l'adresse du lecteur, sinon il se recharge et relance.
  const depart = useRef(departDemande).current;
  const origine = origineSite();

  useEffect(() => {
    const derniere = { position: 0, duree: 0 };
    const envoyer = (rafraichir) => {
      // Sans durée connue, le serveur compterait la vidéo comme vue à 100 % : rien n'est envoyé.
      if (!derniere.duree) return;
      api.post("videoprogress/", { video: videoId, position: Math.round(derniere.position), duration: Math.round(derniere.duree) })
        .then(() => { if (rafraichir) onProgression?.(); })
        .catch(() => {});
    };
    const ecouter = (event) => {
      if (event.origin !== origine || event.data?.source !== "ql-lecteur") return;
      const { type, valeur, position, duree } = event.data;
      if (duree > 0) { derniere.position = position || 0; derniere.duree = duree; }
      if (type === "position") envoyer(false);
      else if (type === "etat" && ETATS_FIN.has(valeur)) envoyer(true);
    };
    window.addEventListener("message", ecouter);
    return () => {
      window.removeEventListener("message", ecouter);
      envoyer(true);
    };
    // Le lecteur est créé une seule fois par vidéo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoId, ytId]);

  return (
    <div className="ql-video-suivie" onContextMenu={(event) => event.preventDefault()}>
      <iframe
        src={urlLecteurYoutube(ytId, { depart })}
        title={titre}
        frameBorder="0"
        allow={AUTORISATIONS_LECTEUR}
        allowFullScreen
      />
    </div>
  );
}
